import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { FlowsDisplayGridRowDataFragment, FlowSortOrder, TableDownstreamFlowsFilteredByColumnQuery, TableDownstreamFlowsFilteredByColumnQueryVariables, TableDownstreamFlowsQuery, TableDownstreamFlowsQueryVariables , TableDownstreamFlowsFilteredByColumnDocument , TableDownstreamFlowsDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = TableDownstreamFlowsQueryVariables;
type QueryResults = TableDownstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamFlowsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamFlowsFilteredByColumnQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const table = resultData && resultData.tables && resultData.tables[0];
  return table.downstreamFlowsConnection;
}


function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  const table = resultData && resultData.tables && resultData.tables[0];
  const column = table && table.columns && table.columns[0];
  return column.downstreamFlowsConnection;
}

export type TableDownstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly tableId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
};

export function TableDownstreamFlowsQueryGrid(props: TableDownstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredColumnId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={TableDownstreamFlowsFilteredByColumnDocument}
        partialQueryVariables={{ tableId: props.tableId, columnId: props.filteredColumnId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={TableDownstreamFlowsDocument}
        partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    )
  )
}
